(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      var cartDrawer = document.getElementsByTagName("BODY")[0];
      cartDrawer.classList.add('header--sticky','shopify-section-cart-hidden');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      var cartDrawer = document.getElementsByTagName("BODY")[0];
      cartDrawer.classList.add('header--sticky');
      cartDrawer.classList.remove('shopify-section-cart-hidden');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      var cartDrawer = document.getElementsByTagName("BODY")[0];
      cartDrawer.classList.remove('header--sticky','shopify-section-cart-hidden');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["iced-summer"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  /* ----- money format helper ----- */
  function money(cents) {
    return '$' + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  /* ----- analytics ----- */
  function fire(event, params) {
    params = params || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'pd_iced_' + event }, params));
    if (typeof gtag === 'function') gtag('event', event, params);
  }

  /* ----- cart API (Rebuy-safe: no drawer code) ----- */
  function addToCart(variantId, qty, btn) {
    if (!variantId) return;
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fire('atc_click', { variant_id: variantId, source: btn.dataset.source });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 })
    })
    .then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); }); })
    .then(function () {
      btn.textContent = 'Added!';
      fire('add_to_cart', { variant_id: variantId, source: btn.dataset.source });
      return fetch('/cart.js').then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      /* dispatch cart:updated so Rebuy can handle the drawer */
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2200);
    })
    .catch(function (err) {
      btn.textContent = 'Try again';
      btn.disabled = false;
      console.error('[pd-iced]', err);
      setTimeout(function () { btn.textContent = orig; }, 2500);
    });
  }

  /* ----- variety pack variant pickers (top section + final CTA repeat) ----- */
  function initVarietyPicker() {
    /* collect all opts across every variety picker on the page */
    var allVarietyOpts = Array.prototype.slice.call(
      document.querySelectorAll('[data-variety-picker] .pd-variant-opt, [data-variety-picker-final] .pd-variant-opt')
    );

    allVarietyOpts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        var vid = opt.dataset.variantId;
        var pf  = opt.dataset.priceFormatted;

        /* sync every variety picker opt across both instances */
        allVarietyOpts.forEach(function (o) {
          var sel = (o.dataset.variantId === vid);
          o.classList.toggle('active', sel);
          o.setAttribute('aria-selected', String(sel));
        });

        /* update all variety ATC buttons */
        document.querySelectorAll('[data-variety-atc-btn], [data-final-variety-btn]').forEach(function (b) {
          b.dataset.variantId = vid;
          b.textContent = 'Add to cart \u2014 ' + pf;
        });

        /* broadcast so sticky bar syncs */
        document.dispatchEvent(new CustomEvent('pd:varietyVariantChanged', {
          detail: { variantId: vid, priceFormatted: pf }
        }));
      });

      opt.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); opt.click(); }
      });
    });
  }

  /* ----- sampler (Best Sellers kit) variant picker ----- */
  function initSamplerPicker() {
    var section = document.querySelector('[data-pd-sampler]');
    if (!section) return;
    var picker = section.querySelector('[data-variant-picker]');
    if (!picker) return;

    var opts = picker.querySelectorAll('.pd-variant-opt');

    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        opts.forEach(function (o) { o.classList.remove('active'); o.setAttribute('aria-selected', 'false'); });
        opt.classList.add('active');
        opt.setAttribute('aria-selected', 'true');

        var vid = opt.dataset.variantId;
        var pf  = opt.dataset.priceFormatted;

        var atcBtn = section.querySelector('[data-sampler-atc-btn]');
        if (atcBtn) { atcBtn.dataset.variantId = vid; atcBtn.textContent = 'Add to cart \u2014 ' + pf; }
      });

      opt.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); opt.click(); }
      });
    });
  }

  /* ----- wire all [data-atc] buttons ----- */
  function initATCButtons() {
    document.querySelectorAll('[data-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addToCart(btn.dataset.variantId, 1, btn);
      });
    });
  }

  /* ----- sticky ATC ----- */
  function initStickyATC() {
    var bar  = document.getElementById('pd-sticky-atc');
    var hero = document.querySelector('[data-pd-hero]');
    if (!bar || !hero) return;

    var select  = bar.querySelector('.pd-sticky-atc__select');
    var priceEl = bar.querySelector('.pd-sticky-atc__price');
    var btn     = bar.querySelector('.pd-sticky-atc__btn');

    /* show/hide on hero scroll */
    var obs = new IntersectionObserver(function (entries) {
      var visible = !entries[0].isIntersecting;
      bar.classList.toggle('is-visible', visible);
      document.body.classList.toggle('pd-sticky-active', visible);
      bar.setAttribute('aria-hidden', String(!visible));
    }, { threshold: 0.1 });
    obs.observe(hero);

    /* sticky select change: update price + variant ID, sync variety picker */
    if (select) {
      select.addEventListener('change', function () {
        var opt = select.options[select.selectedIndex];
        var vid = opt.value;
        var pf  = opt.dataset.priceFormatted || money(Number(opt.dataset.price));
        if (priceEl) priceEl.textContent = pf;
        if (btn) btn.dataset.variantId = vid;

        /* sync all variety pickers (top section + final CTA repeat) */
        document.querySelectorAll('[data-variety-picker] .pd-variant-opt, [data-variety-picker-final] .pd-variant-opt').forEach(function (o) {
          var sel = o.dataset.variantId === vid;
          o.classList.toggle('active', sel);
          o.setAttribute('aria-selected', String(sel));
        });

        /* sync variety ATC + final CTA buttons */
        document.querySelectorAll('[data-variety-atc-btn], [data-final-variety-btn]').forEach(function (b) {
          b.dataset.variantId = vid;
          b.textContent = 'Add to cart \u2014 ' + pf;
        });
      });
    }

    /* sticky ATC button click */
    if (btn) {
      btn.addEventListener('click', function () {
        var vid = select ? select.value : btn.dataset.variantId;
        fire('sticky_atc_click', { variant_id: vid });
        addToCart(vid, 1, btn);
      });
    }

    /* sync when variety picker changes */
    document.addEventListener('pd:varietyVariantChanged', function (e) {
      var vid = e.detail.variantId;
      var pf  = e.detail.priceFormatted;
      if (select) {
        Array.from(select.options).forEach(function (o) { o.selected = (o.value === String(vid)); });
      }
      if (priceEl && pf) priceEl.textContent = pf;
      if (btn) btn.dataset.variantId = vid;
    });
  }

  /* ----- FAQ accordion ----- */
  function initAccordion() {
    document.querySelectorAll('.pd-accordion__trigger').forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded  = trigger.getAttribute('aria-expanded') === 'true';
        var contentId = trigger.getAttribute('aria-controls');
        var content   = document.getElementById(contentId);

        /* collapse all in same accordion */
        var accordion = trigger.closest('.pd-accordion');
        if (accordion) {
          accordion.querySelectorAll('.pd-accordion__trigger').forEach(function (t) {
            t.setAttribute('aria-expanded', 'false');
            var c = document.getElementById(t.getAttribute('aria-controls'));
            if (c) { c.classList.remove('is-open'); c.hidden = true; }
          });
        }

        if (!expanded && content) {
          trigger.setAttribute('aria-expanded', 'true');
          content.hidden = false;
          content.classList.add('is-open');
          fire('faq_open', { question: trigger.textContent.trim().substring(0, 80) });
        }
      });
    });
  }

  /* ----- scroll depth ----- */
  function initScrollDepth() {
    var fired  = {};
    var depths = [25, 50, 75, 100];
    window.addEventListener('scroll', function () {
      var pct = Math.floor(((window.scrollY + window.innerHeight) / document.body.scrollHeight) * 100);
      depths.forEach(function (d) {
        if (pct >= d && !fired[d]) { fired[d] = true; fire('scroll_depth', { depth: d }); }
      });
    }, { passive: true });
  }

  /* ----- analytics on named elements ----- */
  function initAnalyticsLinks() {
    document.querySelectorAll('[data-analytics]').forEach(function (el) {
      el.addEventListener('click', function () {
        fire(el.dataset.analytics, { label: (el.textContent || el.getAttribute('aria-label') || '').trim().substring(0, 80) });
      });
    });
  }

  /* ----- init ----- */
  function init() {
    initVarietyPicker();
    initSamplerPicker();
    initATCButtons();
    initStickyATC();
    initAccordion();
    initScrollDepth();
    initAnalyticsLinks();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }

  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pd-dessert-landing"] && !Shopify.designMode) return;
  try {
    
(function(){
  'use strict';

  function fire(event, params){
    params = params || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event:'pd_dessert_'+event }, params));
    if (typeof gtag === 'function') gtag('event', event, params);
  }

  /* Rebuy-safe add to cart: dispatch cart:updated, no drawer code */
  function addToCart(variantId, qty, btn){
    if (!variantId) return;
    var orig = btn.textContent;
    btn.disabled = true; btn.textContent = 'Adding...';
    fire('atc_click', { variant_id:variantId, source:btn.dataset.source });
    fetch('/cart/add.js', {
      method:'POST',
      headers:{ 'Content-Type':'application/json', Accept:'application/json' },
      body:JSON.stringify({ id:Number(variantId), quantity:qty||1 })
    })
    .then(function(r){ return r.ok ? r.json() : r.json().then(function(e){ throw new Error(e.description || 'Could not add to cart'); }); })
    .then(function(){
      btn.textContent = 'Added!';
      fire('add_to_cart', { variant_id:variantId, source:btn.dataset.source });
      return fetch('/cart.js').then(function(r){ return r.json(); });
    })
    .then(function(cart){
      document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail:{ cart:cart } }));
      setTimeout(function(){ btn.textContent = orig; btn.disabled = false; }, 2200);
    })
    .catch(function(err){
      btn.textContent = 'Try again'; btn.disabled = false;
      console.error('[pd-dessert]', err);
      setTimeout(function(){ btn.textContent = orig; }, 2500);
    });
  }

  /* variant pickers: each offer updates its own ATC button + price */
  function initPickers(){
    document.querySelectorAll('[data-pd-offer]').forEach(function(offer){
      var picker = offer.querySelector('[data-variant-picker]');
      if (!picker) return;
      var opts = picker.querySelectorAll('.pd-variant-opt');
      var atc  = offer.querySelector('[data-atc]');
      var priceNow = offer.querySelector('[data-price-now]');
      opts.forEach(function(opt){
        function select(){
          opts.forEach(function(o){ o.classList.remove('active'); o.setAttribute('aria-selected','false'); });
          opt.classList.add('active'); opt.setAttribute('aria-selected','true');
          var vid = opt.dataset.variantId, pf = opt.dataset.priceFormatted;
          if (atc){ atc.dataset.variantId = vid; atc.textContent = 'Add to cart \u2014 ' + pf; }
          if (priceNow){ priceNow.textContent = pf; }
        }
        opt.addEventListener('click', select);
        opt.addEventListener('keydown', function(e){ if (e.key==='Enter'||e.key===' '){ e.preventDefault(); select(); } });
      });
    });
  }

  function initATC(){
    document.querySelectorAll('[data-atc]').forEach(function(btn){
      btn.addEventListener('click', function(){ addToCart(btn.dataset.variantId, 1, btn); });
    });
  }

  /* smooth scroll for final-CTA buttons back up to their sections */
  function initScrollLinks(){
    document.querySelectorAll('[data-scroll]').forEach(function(a){
      a.addEventListener('click', function(e){
        var id = a.getAttribute('href');
        var target = id && document.querySelector(id);
        if (target){ e.preventDefault(); target.scrollIntoView({ behavior:'smooth', block:'start' }); }
      });
    });
  }

  function initAccordion(){
    document.querySelectorAll('.pd-accordion__trigger').forEach(function(trigger){
      trigger.addEventListener('click', function(){
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var accordion = trigger.closest('.pd-accordion');
        if (accordion){
          accordion.querySelectorAll('.pd-accordion__trigger').forEach(function(t){
            t.setAttribute('aria-expanded','false');
            var c = document.getElementById(t.getAttribute('aria-controls'));
            if (c){ c.classList.remove('is-open'); c.hidden = true; }
          });
        }
        if (!expanded){
          var content = document.getElementById(trigger.getAttribute('aria-controls'));
          trigger.setAttribute('aria-expanded','true');
          if (content){ content.hidden = false; content.classList.add('is-open'); }
          fire('faq_open', { question: trigger.textContent.trim().substring(0,80) });
        }
      });
    });
  }

  function initAnalytics(){
    document.querySelectorAll('[data-analytics]').forEach(function(el){
      el.addEventListener('click', function(){
        fire(el.dataset.analytics, { label:(el.textContent||el.getAttribute('aria-label')||'').trim().substring(0,80) });
      });
    });
  }

  function init(){ initPickers(); initATC(); initScrollLinks(); initAccordion(); initAnalytics(); }
  if (document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          document.querySelectorAll('.btn_variant_select').forEach(function(e){
            var variant_code
            e.addEventListener('change',function(event){
              variant_code = this.options[this.selectedIndex].dataset.id;
              if(event.target.classList.contains('cart_function')){
                if(variant_code != undefined){
                  this.parentElement.parentElement.nextElementSibling.querySelector('#Button_addcart_reward').dataset.id = variant_code;
                  // this.parentElement.parentElement.nextElementSibling.querySelector('#Button_addcart_reward').classList.remove("disable");
                }
              }else{
                if(variant_code != undefined){
                  this.parentElement.parentElement.nextElementSibling.dataset.id = variant_code;
                  this.parentElement.parentElement.nextElementSibling.classList.remove("disable");
                }
              }
            })
          })
           
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["refer-a-friend-coldlander"] && !Shopify.designMode) return;
  try {
    
(function () {
  'use strict';

  function addToCart(variantId, btn) {
    if (!variantId) return;
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    })
    .then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw new Error(e.description || 'Could not add'); }); })
    .then(function () {
      btn.textContent = 'Added!';
      return fetch('/cart.js').then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2000);
    })
    .catch(function (err) {
      btn.textContent = 'Try again';
      btn.disabled = false;
      console.error('[pdraf]', err);
      setTimeout(function () { btn.textContent = orig; }, 2200);
    });
  }

  function initSamplerPicker() {
    var picker = document.querySelector('[data-variant-picker]');
    if (!picker) return;
    var opts = picker.querySelectorAll('.pdraf-vopt');
    var atc = document.querySelector('[data-bs-atc]');
    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        opts.forEach(function (o) { o.classList.remove('active'); o.setAttribute('aria-selected', 'false'); });
        opt.classList.add('active');
        opt.setAttribute('aria-selected', 'true');
        if (atc) {
          atc.dataset.variantId = opt.dataset.variantId;
          atc.textContent = 'Add to cart \u2014 ' + opt.dataset.priceFormatted;
        }
      });
      opt.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); opt.click(); }
      });
    });
  }

  function initATC() {
    document.querySelectorAll('[data-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () { addToCart(btn.dataset.variantId, btn); });
    });
  }

  function init() { initSamplerPicker(); initATC(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sweater-weather"]) return;
  try {
    
(function () {
  'use strict';

  /* ----- analytics ----- */
  function fire(event, params) {
    params = params || {};
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: 'pd_sw_' + event }, params));
    if (typeof gtag === 'function') gtag('event', event, params);
  }

  /* ----- cart API (Rebuy-safe: no cart-drawer.js dependency) ----- */
  function addToCart(variantId, qty, btn) {
    if (!variantId) return;
    var orig = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding...';

    fire('atc_click', { variant_id: variantId, source: btn.dataset.source });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: Number(variantId), quantity: qty || 1 })
    })
    .then(function (r) { return r.ok ? r.json() : r.json().then(function (e) { throw new Error(e.description || 'Could not add to cart'); }); })
    .then(function () {
      btn.textContent = 'Added!';
      fire('add_to_cart', { variant_id: variantId, source: btn.dataset.source });
      return fetch('/cart.js').then(function (r) { return r.json(); });
    })
    .then(function (cart) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
      setTimeout(function () { btn.textContent = orig; btn.disabled = false; }, 2200);
    })
    .catch(function (err) {
      btn.textContent = 'Try again';
      btn.disabled = false;
      console.error('[pd-sweater-weather]', err);
      setTimeout(function () { btn.textContent = orig; }, 2500);
    });
  }

  /* ----- wire all [data-atc] buttons ----- */
  function initATCButtons() {
    document.querySelectorAll('[data-atc]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        addToCart(btn.dataset.variantId, 1, btn);
      });
    });
  }

  /* ----- secondary offer (Best Sellers) variant picker ----- */
  function initSecondaryPicker() {
    var picker = document.querySelector('#best-sellers [data-variant-picker]');
    if (!picker) return;
    var opts = picker.querySelectorAll('.pd-variant-opt');
    var atcBtn = document.querySelector('#best-sellers [data-secondary-atc-btn]');

    opts.forEach(function (opt) {
      opt.addEventListener('click', function () {
        opts.forEach(function (o) { o.classList.remove('active'); o.setAttribute('aria-selected', 'false'); });
        opt.classList.add('active');
        opt.setAttribute('aria-selected', 'true');

        var vid = opt.dataset.variantId;
        var pf  = opt.dataset.priceFormatted;
        if (atcBtn) { atcBtn.dataset.variantId = vid; atcBtn.textContent = 'Add to cart — ' + pf; }
      });

      opt.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); opt.click(); }
      });
    });
  }

  function init() {
    initATCButtons();
    initSecondaryPicker();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
}());

  } catch(e) { console.error(e); }
})();
})();
